import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';

window.__FFC_VERSION__ = '2.1.0';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

